import { useMemo, useRef } from 'react';
import Portal from '../../../../../components/other/portal';

import './styles.scss';

const PostShiftsSidebar = ({ selectedShiftsToPost, handleClose, setSelectedShiftsToPost, handlePost }) => {
  const ref = useRef();

  const groupedShiftsByDay = useMemo(() => {
    const groupedShiftsByDay = {};

    selectedShiftsToPost.forEach((shift) => {
      const date = new Date(shift.cell.day);

      const formatted = date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
      });

      const weekday = date.toLocaleDateString('en-US', {
        weekday: 'long',
      });

      const day = `${formatted} ${weekday}`;

      if (!groupedShiftsByDay[day]) {
        groupedShiftsByDay[day] = [];
      }
      groupedShiftsByDay[day].push(shift);
    });

    return groupedShiftsByDay;
  }, [selectedShiftsToPost]);

  return (
    <Portal>
      <div className="post-shifts-sidebar" ref={ref}>
        <div className="post-shifts-sidebar-header">
          <div className="post-shifts-sidebar-header-title-wrapper">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="2" width="32" height="32" rx="16" fill="#F4EBFF" />
              <rect x="2" y="2" width="32" height="32" rx="16" stroke="#F9F5FF" strokeWidth="4" />
              <path
                d="M23.3332 24V22.6667C23.3332 21.9594 23.0522 21.2811 22.5521 20.781C22.052 20.281 21.3737 20 20.6665 20H15.3332C14.6259 20 13.9476 20.281 13.4476 20.781C12.9475 21.2811 12.6665 21.9594 12.6665 22.6667V24M20.6665 14.6667C20.6665 16.1394 19.4726 17.3333 17.9998 17.3333C16.5271 17.3333 15.3332 16.1394 15.3332 14.6667C15.3332 13.1939 16.5271 12 17.9998 12C19.4726 12 20.6665 13.1939 20.6665 14.6667Z"
                stroke="#7F56D9"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Post shifts
          </div>
          <button className="btn btn-icon" onClick={handleClose}>
            <i className="icon-icon-x"></i>
          </button>
        </div>
        <div className="post-shifts-sidebar-subheader"></div>
        <div className="post-shifts-sidebar-body">
          <div className="post-shifts-list">
            {Object.keys(groupedShiftsByDay).map((day) => (
              <div className="post-shifts-list-item" key={day}>
                <div className="post-shifts-list-item-name-wrapper">
                  <div className="post-shifts-list-item-name">{day}</div>
                </div>
                <div className="post-shifts-list-item-shift">
                  {groupedShiftsByDay[day].map((shift) => (
                    <div className="post-shifts-list-item-cell-wrapper" key={shift.cell.id}>
                      <div className="post-shifts-cell-item-left-block">
                        {shift.unitName}, <strong>{shift.roleName}</strong>
                      </div>
                      <div className="post-shifts-cell-item-center-block">
                        shift {shift.shiftName}{' '}
                        {shift.halfPart == 'first_half' ? '/ 1st half' : shift.halfPart == 'second_half' ? '/ 2nd half' : ''}
                      </div>
                      <div className="post-shifts-cell-item-right-block">
                        <button
                          className="post-shifts-cell-item-delete-btn"
                          onClick={() => setSelectedShiftsToPost((prevState) => prevState.filter((item) => item.cell.id !== shift.cell.id))}
                        >
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M2.5 5.00033H4.16667M4.16667 5.00033H17.5M4.16667 5.00033V16.667C4.16667 17.109 4.34226 17.5329 4.65482 17.8455C4.96738 18.1581 5.39131 18.3337 5.83333 18.3337H14.1667C14.6087 18.3337 15.0326 18.1581 15.3452 17.8455C15.6577 17.5329 15.8333 17.109 15.8333 16.667V5.00033H4.16667ZM6.66667 5.00033V3.33366C6.66667 2.89163 6.84226 2.46771 7.15482 2.15515C7.46738 1.84259 7.89131 1.66699 8.33333 1.66699H11.6667C12.1087 1.66699 12.5326 1.84259 12.8452 2.15515C13.1577 2.46771 13.3333 2.89163 13.3333 3.33366V5.00033M8.33333 9.16699V14.167M11.6667 9.16699V14.167"
                              stroke="#CBD2E0"
                              strokeWidth="1.66667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}

            <div className="bottom-buttons">
              <button className="btn btn-outline" onClick={handleClose}>
                Cancel
              </button>
              <button className="btn" onClick={handlePost} disabled={!selectedShiftsToPost.length}>
                Post Shifts to Staff
              </button>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default PostShiftsSidebar;
